var TorsoView = require('backbone-torso/modules/View');
var pdfViewerWidgetTemplate = require('./pdfViewerWidgetTemplate.hbs');
var launcherAppInterface = require('./../../launcherApplicationInterface');
var localStorageService = require('./../../storage/localStorageService');

/**
 * Class for viewing a pdf
 *
 * @class PdfViewerWidget
 * @constructor
 * @param options {Object}
 * @param options.model {Torso.Model}
 */
module.exports = TorsoView.extend({
  className: 'brec-pdf-viewer__iframe-container',
  template: pdfViewerWidgetTemplate,

  /**
   * Adds attributes to the the top level element (this is to support existing behavioral tests that query these values).
   * @returns {{data-test-pdf-viewer: true}}
   */
  attributes: {
    'data-test-pdf-viewer': true
  },

  /**
   * @private
   * @property _pdfUrl {String} The URL of the pdf to be viewed.
   * Set on initialize and never changed
   */
  _pdfUrl: null,

  /**
   * @method initialize
   * @param options
   *   @param options.pdfUrl {String} url of the pdf to view
   * @override
   */
  initialize : function(options) {
    this._pdfUrl = options.pdfUrl;
    // Clear session information for pdf view to avoid any previous state.
    localStorageService.removeItem(localStorageService.LOCAL_STORAGE_KEYS.pdfjsDatabase);
  },

  /**
   * @method prepare
   * @override
   */
  prepare : function() {
    var templateContext = TorsoView.prototype.prepare.apply(this);
    templateContext.pdfUrl = this._pdfUrl;
    templateContext.isOnTablet = launcherAppInterface.isAtHospital();
    return templateContext;
  }
});
